import { CloudBottomSheetProps } from './CloudBottomSheet.interface';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { useCurrentLang, useTranslator } from '$hooks';
import { CellButton } from '$uikit';
import './CloudBottomSheet.sass';

export const CloudBottomSheet = ({
  type,
  actionItems,
  albumItems,
}: CloudBottomSheetProps) => {
  const t = useTranslator();
  const { key } = useCurrentLang();

  const getItemsCountText = () => {
    const itemsCount = albumItems.reduce((itemsCount, item) => {
      const { elementType } = item;

      if (elementType in itemsCount) {
        itemsCount[elementType] += 1;
      } else {
        itemsCount[elementType] = 1;
      }

      return itemsCount;
    }, {});

    const items = Object.entries(itemsCount);

    if (items.length > 1) {
      return items.map(([type, count]) => t(`cloud_storage_${type}_count`, { count }));
    }

    return t(`cloud_storage_${items[0][0]}_count`, { count: items[0][1] });
  };

  const getText = () => {
    const itemsCount = getItemsCountText();
    const itemsText = Array.isArray(itemsCount) ? (
      itemsCount.map((item, ind) => {
        if (ind !== itemsCount.length - 1) {
          return (
            <>
              <b>{item}</b> {t('cloud_storage_and')}{' '}
            </>
          );
        }

        return <b key={ind}>{item}</b>;
      })
    ) : (
      <b>{itemsCount}</b>
    );

    if (type === 'delete') {
      return (
        <>
          {t('cloud_storage_delete_confirm')} {itemsText}?
        </>
      );
    }

    if (key === 'en') {
      return (
        <>
          {itemsText} {t('cloud_storage_send_selected')}
        </>
      );
    }

    return (
      <>
        {t('cloud_storage_send_selected')} {itemsText}
      </>
    );
  };

  return (
    <BottomSheet
      title={t(type === 'share' ? 'cloud_storage_send' : 'cloud_storage_delete_media')}
    >
      <div className="CloudBottomSheet__text">{getText()}</div>
      <div className="CloudBottomSheet__btns">
        {actionItems.map((actionItem, index) => {
          const { title, icon, onClick } = actionItem;

          return (
            <CellButton key={index} onClick={onClick}>
              {icon} {title}
            </CellButton>
          );
        })}
      </div>
    </BottomSheet>
  );
};
